import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.CiderMan,
  voices: {
    main: {
      description:
        "nimble young tenor, friendly acrobatic quips, bright action-camera clarity, quick breath after flips, sincere under pressure",
      seed: 10685,
      guidance: 0.76,
      loudness: 0.78,
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "I'm your Friendly Neighborhood Cider-Man, only my neighborhood is now, like, multiple realities. Cool, right?",
      },
      { id: "select_2", text: "C'mon, I'm right here. You know, Cider-Man?" },
      {
        id: "select_3",
        text: "I mean, it's not like Cider-Man could help or anything…",
      },
      { id: "select_4", text: "Yoohoo, Cider-Man over here!" },
    ],
    spawn: [
      {
        id: "spawn_1",
        text: "Some bonds just can’t be broken… no matter how hard you try…",
      },
      {
        id: "spawn_2",
        text: "Thought I was done with symbiotes. But desperate times call for desperate partnerships…",
      },
      {
        id: "spawn_3",
        text: "Gotta be careful! So many ways this could blow up in my face!",
      },
      {
        id: "spawn_4",
        text: "Thanks for the upgrade, Peni! These Nano-Tracers really hit the mark!",
      },
      {
        id: "spawn_5",
        text: "Travel tip: With the right credit card, interdimensional trips get crazy extra miles.",
      },
      {
        id: "spawn_6",
        text: "The truth is, I can do some amazing stuff. I should enjoy this more.",
      },
      {
        id: "spawn_7",
        text: "I don't know the actual mileage, but this feels like a long way from Queens.",
      },
      {
        id: "spawn_8",
        text: "This feels like an Avengers gig. Does that mean I've made it to the big leagues?",
      },
      {
        id: "spawn_9",
        text: "So if the timelines are all entangled, how many MJs are there? This could get complicated.",
      },
      {
        id: "spawn_10",
        text: "That spider could have bitten anyone, but it bit me. Pretty amazing luck.",
      },
      {
        id: "spawn_11",
        text: "Life is hard sometimes, but at least maybe I can make it easier for other people.",
      },
      {
        id: "spawn_12",
        text: "Please can we discover Aunt May's Cherry Pie dimension?",
      },
      {
        id: "spawn_13",
        text: "It's up to us to help the people who can't help themselves.",
      },
      {
        id: "spawn_14",
        text: "Someone's got to stop Doom. I mean, Dooms. Hope there's only two?",
      },
      {
        id: "spawn_15",
        text: "Doing the right thing just makes you feel good, doesn't it?",
      },
      {
        id: "spawn_16",
        text: "Anybody who has the chance can be a hero. I believe that.",
      },
      {
        id: "spawn_17",
        text: "Come to New York sometime, I'll do whatever a spider can!",
      },
      {
        id: "spawn_18",
        text: "Where's the timeline where we all just go down to the bodega for a sandwich?",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "I gotta do better this time." },
      { id: "respawn_2", text: "Now I've got something to prove." },
      {
        id: "respawn_3",
        text: "I'm not a vengeful person, but today I'll make an exception.",
      },
      { id: "respawn_4", text: "Back in the swing of things!" },
    ],
    ult_ally: [
      {
        id: "ult_ally",
        text: "You get a web, and you get a web, and you get a web!",
      },
    ],
    ult_enemy: [
      { id: "ult_enemy", text: "Don't mess with the Amazing Cider-Man!" },
    ],
    ability2: [
      { id: "ability2_1", text: "Now I gotcha!" },
      { id: "ability2_2", text: "Spider-Sling!" },
      { id: "ability2_3", text: "Crack the whip!" },
    ],
    ability3: [
      { id: "ability3_1", text: "Spider-Fist is ready to punch!" },
      { id: "ability3_2", text: "Ground and pound!" },
      { id: "ability3_3", text: "Gonna get sticky…" },
    ],
    kill: [
      { id: "kill_1", text: "Fight for the good guys next time!" },
      { id: "kill_2", text: "You'll be all right. Someday." },
      { id: "kill_3", text: "Ohhh, you went down pretty hard." },
      { id: "kill_4", text: "And stay down." },
      { id: "kill_5", text: "Yeah! Woo!" },
      { id: "kill_6", text: "Whooo, no webs needed." },
      { id: "kill_7", text: "I don't want to hit you more than I have to." },
      { id: "kill_8", text: "Stay down, willya?" },
    ],
    multikill: [
      { id: "multikill_1", text: "Good things come in threes." },
      { id: "multikill_2", text: "Three is the magic number." },
      { id: "multikill_3", text: "Easy as 1-2-3!" },
      { id: "multikill_4", text: "Maybe I'm getting good at this hero thing!" },
      { id: "multikill_5", text: "I think that's five in a row! Crazy!" },
      { id: "multikill_6", text: "Five? Can't be many of them left!" },
      {
        id: "multikill_7",
        text: "Hey, sorry, team. There's no bad guys left.",
      },
      {
        id: "multikill_8",
        text: "Aw, jeez, I didn't mean to hog the bad guys.",
      },
      {
        id: "multikill_9",
        text: "Don't worry. You guys can win some next time.",
      },
    ],
    low_hp: [
      { id: "low_hp_1", text: "That hit the spot." },
      { id: "low_hp_2", text: "You're a life-saver." },
    ],
    healed: [
      { id: "healed_1", text: "That put some pep in my step!" },
      { id: "healed_2", text: "Nice!" },
      { id: "healed_3", text: "Better than Aunt May's chicken soup." },
      { id: "healed_4", text: "Feeling good!" },
    ],
  },
} satisfies VoiceScript;

export default script;
